import {
    GET_AUTOMATED_DISCOUNTS_ERROR,
    GET_AUTOMATED_DISCOUNTS_SUCCESS,
    GET_PRODUCT_BY_ID,
    GET_PRODUCT_BY_ID_ERROR,
    GET_PRODUCT_BY_ID_SUCCESS,
    RESOLVE_REDIRECT_SUCCESS,
    RESOLVE_SEARCH_SUCCESS,
    RESOLVE_SLUG,
    RESOLVE_SLUG_ERROR,
    RESOLVE_SLUG_SUCCESS,
} from "./constants";

import produce from "immer";

// The initial state of this store.
const initialState = {
    isFetching: null,
    data: null,
    type: null,
    template: null,
    relationships: null,
    localeAlternates: [],
    search: "",
};

export default produce((state, action) => {
    switch (action.type) {
        case RESOLVE_SLUG:
            state.isFetching = true;
            break;
        case RESOLVE_SLUG_SUCCESS:
            state.isFetching = false;
            state.data = action.pageData ? action.pageData : null;
            state.type = action.pageType ? action.pageType : null;
            state.template = action.pageTemplate ? action.pageTemplate : null;
            state.relationships = action.pageRelationships ? action.pageRelationships : null;
            state.search = action.pageSearch;
            state.localeAlternates = action.localeAlternates;
            break;
        case RESOLVE_SLUG_ERROR:
            return initialState;
        case RESOLVE_REDIRECT_SUCCESS:
            state.isFetching = false;
            state.data = action.pageData ? action.pageData : null;
            state.type = action.pageType ? action.pageType : null;
            break;
        case RESOLVE_SEARCH_SUCCESS:
            state.search = action.pageSearch;
            break;
        case GET_PRODUCT_BY_ID: {
            break;
        }
        case GET_PRODUCT_BY_ID_SUCCESS: {
            state.data.product = action.product;
            break;
        }
        case GET_PRODUCT_BY_ID_ERROR: {
            break;
        }
        case GET_AUTOMATED_DISCOUNTS_SUCCESS: {
            if (!!action.product) {
                state.data.product = action.product;
            }
            state.data.product.variants = action.variants;
            state.data.automatedDiscountData = action.automatedDiscountData;
            state.data.selectedProductVariants = action.selectedProductVariants;
            break;
        }
        case GET_AUTOMATED_DISCOUNTS_ERROR: {
            break;
        }
        default:
            break;
    }
}, initialState);
